import { createUrl } from "@/redux/api";
import {
  CreateUpdateInvite,
  UserInviteResponse,
  InviteQueryParams,
  Tags,
  TagType,
} from "@/redux/invites/types";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const invitesService = (builder: BuilderType<Tags>) => ({
  getUserInvites: builder.query<
    UserInviteResponse[] | PaginatedResponse<UserInviteResponse>,
    InviteQueryParams
  >({
    query: (filters) => ({
      url: createUrl("/invites/", filters),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result
        ? [
            ...(
              (isPaginatedResponse(result)
                ? result.results
                : result) as UserInviteResponse[]
            ).map(
              (i): TagType => ({
                type: "UserInvite",
                id: i.id,
              }),
            ),
            { type: "UserInvites" },
          ]
        : [],
  }),
  createUserInvite: builder.mutation<UserInviteResponse, CreateUpdateInvite>({
    query: (data) => ({
      url: `/invites/`,
      method: "POST",
      data,
    }),
    invalidatesTags: (result) => (result ? [{ type: "UserInvites" }] : []),
  }),
  patchUserInviteById: builder.mutation<
    UserInviteResponse,
    { id: number; data: CreateUpdateInvite }
  >({
    query: ({ id, data }) => ({
      url: `/invites/${id}/`,
      method: "PATCH",
      data,
    }),
    invalidatesTags: (result) =>
      result ? [{ type: "UserInvite", id: result.id }] : [],
  }),
  deleteUserInviteById: builder.mutation<null, number>({
    query: (id) => ({
      url: `/invites/${id}/`,
      method: "DELETE",
    }),
    invalidatesTags: [{ type: "UserInvites" }],
  }),
  verifyUserInviteEmail: builder.query({
    query: (token) => createUrl("/invites/email-verification/", { token }),
  }),
});

export default invitesService;
